import React, { useState } from "react";
import openSocket from 'socket.io-client';
import Swal from "sweetalert2";

let SocketInstance;
import Cookies from "js-cookie";
import { SCHOOL_INFO } from "utils/constants";

export const initConeection = (server, token) => {

    SocketInstance = openSocket(server);
    let failed_to_connect = false;

    SocketInstance.on("connect", () => {
        failed_to_connect = false;
        SocketInstance.emit("auth", { token: token });
        Swal.close();
        SocketInstance.on("disconnect", () => {
            failed_to_connect = true ;
            Swal.fire("Make sure internet is connected and refresh the page!", "", "error");
        })

    })


    SocketInstance.on("connect_error", (err) => {
        if(!failed_to_connect){

            Swal.fire("Make sure internet is connected and refresh the page!", "", "error");
            failed_to_connect = true ;
        }
    });



}


export const readNotification = (notification_id, token) => {
    SocketInstance.emit("readNotification", { id: notification_id, token: token });
}

function readMorFunction(id) {
    var dots = document.getElementById(id + "dots");
    var moreText = document.getElementById(id + "more");
    var btnText = document.getElementById(id + "button");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
}

const Socket = (props) => {


    const [notifications, setNotifications] = useState([]);
    if (SocketInstance) {


        SocketInstance.on("notifications", (res) => {

            setNotifications(res)
        });
        SocketInstance.on("notificationAdded", (res) => {
            let find = notifications.findIndex((notif) => notif.id == res.id);
            if (find == -1) {
                let tempNotifications = [...notifications];
                tempNotifications.push(res);
                setNotifications(tempNotifications)
            }

        });
    }

    if (SocketInstance && notifications.length > 0) {

        SocketInstance.on("notificationReaded", (res) => {

            let filteredArray = notifications.filter((notification) => notification.id != res.id);


            setNotifications(filteredArray)
        })

    }

    return (
        <div >

            <div className=" toast-container " style={{ position: "absolute", top: "0", right: "0", zIndex: 1500 }}>
                {notifications?.map((notification, index) => {
                    let date = new Date(notification.createdAt);

                    return (
                        <div key={index}>
                            <div className="toast show" role="alert" aria-live="assertive" aria-atomic="true">
                                <div className="toast-header">
                                    <img width="10%" height="10%" src={SCHOOL_INFO.logo} className="rounded me-2" alt="..." />
                                    <strong className="me-auto">New notification :  {notification.subject} </strong>
                                    <button type="button" className="btn-close" onClick={() => { readNotification(notification.id, Cookies.get("studentportaltoken")) }} aria-label="Close"></button>
                                </div>
                                <div className="toast-body text-bold " style={{ backgroundColor: "white" }}>
                                    {notification.body.slice(0, 200)}
                                    {notification.body.length > 200 ? (
                                        <>
                                            <span id={notification.id + "dots"}>......</span>
                                            <span style={{ display: "none" }} id={notification.id + "more"}>{notification.body.slice(200, notification.body.length)}</span>
                                            <button class="btn btn-primary" onClick={() => { readMorFunction(notification.id) }} id={notification.id + "button"}>Read more</button>
                                        </>
                                    ) : ""}
                                    {notification.link ? (<div className="text-left "><a target="_blank" href={notification.link}>Go to link</a></div>) : null}
                                    <div className="text-right "> <small className="text-muted ">since {date.toDateString()}</small></div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}




export default Socket